export default {
  methods: {
    getExcelFields() {
      return {
        [this.$t("tks.grainNames")]: {
          field: "selectedCerealType",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("tks.deviceNames")]: {
          field: "deviceName",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("tks.airInitialTemperature")]: {
          field: "airInitialTemperature",
          callback: (value) => {
            return value + " °C";
          },
        },
        [this.$t("tks.airInitialHumidity")]: {
          field: "airInitialHumidity",
          callback: (value) => {
            return value + " %";
          },
        },
        [this.$t("tks.airFinalTemperature")]: {
          field: "airFinalTemperature",
          callback: (value) => {
            return value + " °C";
          },
        },
        [this.$t("tks.airFinalHumidity")]: {
          field: "airFinalHumidity",
          callback: (value) => {
            return value + " %";
          },
        },
        [this.$t("tks.siloHeight")]: {
          field: "siloHeight",
          callback: (value) => {
            return value + " m";
          },
        },
        [this.$t("tks.grainWeight")]: {
          field: "grainWeight",
          callback: (value) => {
            return value + " TON";
          },
        },
        [this.$t("tks.capacity")]: {
          field: "capacity",
          callback: (value) => {
            return value + " kW";
          },
        },
        [this.$t("tks.coolingDurationHouse")]: {
          field: "hour",
          callback: (value) => {
            return value + " " + this.$t("tks.house");
          },
        },
        [this.$t("tks.coolingDurationDay")]: {
          field: "day",
          callback: (value) => {
            return value + " " + this.$t("tks.day");
          },
        },
        [this.$t("tks.connectionDimensions")]: {
          field: "connectionDimensions",
          callback: (value) => {
            return value + " m";
          },
        },
        [this.$t("tks.maximumFanAirFlowRate")]: {
          field: "maximumFanAirFlowRate",
          callback: (value) => {
            return value + " m³/h";
          },
        },
        [this.$t("tks.maximumFanPressure")]: {
          field: "maximumFanPressure",
          callback: () => {
            // return value + " Pa";
            return "6000 Pa";
          },
        },
        [this.$t("tks.electricalData")]: {
          field: "electricalData",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("tks.operatingCurrent")]: {
          field: "operatingCurrent",
          callback: (value) => {
            return value + " A";
          },
        },
        [this.$t("tks.maximumOperatingCurrent")]: {
          field: "maximumOperatingCurrent",
          callback: (value) => {
            return value + " A";
          },
        },
        [this.$t("tks.operatingPowerConsumption")]: {
          field: "operatingPowerConsumption",
          callback: (value) => {
            return value + " kW";
          },
        },
        [this.$t("tks.fanFlowRate")]: {
          field: "fanFlowRate",
          callback: (value) => {
            return value + " m³/h";
          },
        },

        [this.$t("common.createdDate")]: {
          field: "createdDate",
          callback: (value) => {
            return this.$date.format(value);
          },
        },
        [this.$t("common.isActive")]: {
          field: "isActive",
          callback: (value) => {
            return value ? this.$t("common.active") : this.$t("common.passive");
          },
        },
      };
    },
  },
};
